module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "klarnaCode",
    staticStyle: {
      "overflow-x": "hidden"
    },
    attrs: {
      "id": "klarna-checkout-container"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0221c1be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/KlarnaCheckout.vue
// module id = 899
// module chunks = 0